export function DocumentPageErrorBox({ error }: { error: string | undefined }) {
  if (!error) return null;

  return (
    <div className="bg-red-50 text-sm rounded border px-3 py-2 dark:bg-zinc-700 dark:border-zinc-700 dark:text-zinc-100">
      <p className="text-red-500 dark:text-red-400">{error}</p>
    </div>
  );
}
